import * as React from "react";

const PaginationArrowRight: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 11 18"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M11 9l-.992.991-7.023 7.014-.997.995L0 16.014l.992-.991L7.023 9 .996 2.977 0 1.986 1.988 0l.992.995 7.024 7.014z" />
        </svg>
    );
};

export default React.memo(PaginationArrowRight);
